// extracted by mini-css-extract-plugin
export var section = "section-module--section--cJFcl";
export var sectionHeading = "section-module--section-heading--HOKLW";
export var sectionContent = "section-module--section-content--3wWfw";